import { TemplateRef, ViewContainerRef } from '@angular/core';

import { ApplicationModeEnum } from '~/core/enums/application-mode.enum';
import { CustomHeadersEnum } from '~/core/enums/custom-headers.enum';
import { IncomingRequestService } from '~/core/services/incoming-request/incoming-request.service';

export abstract class AppModeDirective {
  protected constructor(
    protected readonly templateRef: TemplateRef<Element>,
    protected readonly viewContainer: ViewContainerRef,
    protected readonly incomingRequestService: IncomingRequestService
  ) {}

  get appMode(): string {
    return this.incomingRequestService.getHeader(
      CustomHeadersEnum.X_APP_MODE,
      ApplicationModeEnum.Full
    );
  }

  public clear(): void {
    this.viewContainer.clear();
  }

  public render(): void {
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
